var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayersBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bky9a",
    d: "M887 375l-29-14 29-14 29 14-29 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bky9b",
    d: "M909.787 368.002L916 371l-29 14-29-14 6.214-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bky9c",
    d: "M909.787 378.002L916 381l-29 14-29-14 6.214-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-857 -346)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#bky9a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#bky9b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#bky9c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersBlue);
export default __webpack_public_path__ + "static/media/layers-blue.7e1aba28379e35f978bb36e5eb44e663.svg";
export { ForwardRef as ReactComponent };